<template lang='pug' src='./block-function-button-2.pug'></template>

<script>
export default {
  props: {
    content: {
      Type: Object,
      default () {}
    },
    function1: {
      Type: Function,
      default () {}
    }
  }
}
</script>



// WEBPACK FOOTER //
// block-function-button-2.vue?b599ba16